/* Quantos meses o histórico representa.
 *
 * A etapa oferece QUATRO cortes: trimestre, semestre, nove meses e o ano. Não
 * é limitação técnica (o motor anualiza qualquer cobertura de 1 a 12, e a API
 * aceita a faixa inteira): é a lista curta que faz a escolha ser respondida
 * em um olhar. Quem tem sete meses de histórico informa seis e guarda o
 * excedente, o que é mais honesto que projetar o ano a partir de um corte que
 * o integrador nunca conta assim.
 *
 * Nenhum vem marcado. Cobertura é a premissa que multiplica o volume anual
 * inteiro: com um valor pré-escolhido, quem não olhasse a lista anualizaria
 * por um número que não declarou. */

export const COBERTURAS = [3, 6, 9, 12] as const;

export type Cobertura = (typeof COBERTURAS)[number];

/**
 * A cobertura correspondente, ou `null` quando o número não é um dos cortes
 * oferecidos. Serve às duas portas de entrada, o dado que vem do banco e o
 * rádio que o usuário marca, para que só exista um lugar que diz o que vale.
 */
export function coberturaOferecida(meses: number | string): Cobertura | null {
  const n = Number(meses);
  return COBERTURAS.find((corte) => corte === n) ?? null;
}
